import type { TaskOutcomeField } from '@erp/shared-types';
import { useTaskTypes } from '@/api/rpc/hooks/tasks/useTaskTypes';

const NO_FIELDS: readonly TaskOutcomeField[] = [];

/**
 * Current outcome fields of each task type, read live from the registry so
 * toggling "Show as badge" applies to tasks that already concluded (their
 * pinned contract snapshot does not carry display settings).
 */
export function useTaskTypeBadgeFields(enabled: boolean) {
  // Archived types included: a concluded task keeps its archived type's id.
  const { data } = useTaskTypes({ enabled, includeArchived: true });
  const byTypeId = new Map(
    (data ?? []).map((type) => [type.id, type.outcomeFields ?? NO_FIELDS]),
  );
  return (taskTypeId: string | null) =>
    (taskTypeId && byTypeId.get(taskTypeId)) || NO_FIELDS;
}
